// resources/js/components/SensitivityDrawer.jsx
import React, { useState } from 'react';
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Slider,
    Button, Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const SensitivityDrawer = ({ open, onClose, initialThreshold, initialSensitivity, onSave }) => {
    const [threshold, setThreshold] = useState(initialThreshold);
    const [sensitivity, setSensitivity] = useState(initialSensitivity);
    const thresholdMarks = [
        {
            value: 0,
            label: '0',
        },
        {
            value: 15,
            label: '15 Default value',
        },
        {
            value: 100,
            label: '100',
        },
    ];
    const sensitivityMarks = [
        {
            value: 0,
            label: '0',
        },
        {
            value: 85,
            label: '85 Default value',
        },
        {
            value: 100,
            label: '100',
        },
    ];
    const handleSave = () => {
        onSave({ threshold, sensitivity });
        onClose();
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: { width: '30%' },
            }}
        >
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Typography variant="h6">Sensitivity Settings</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography gutterBottom>Motion Threshold <b>{threshold}</b></Typography>
                    <Slider
                        value={threshold}
                        onChange={(e, value) => setThreshold(value)}
                        min={0}
                        marks={thresholdMarks}
                        max={100}
                        valueLabelDisplay="on"
                    />
                </Box>
                <Box sx={{ mb: 4 }}>
                    <Typography gutterBottom>Motion Sensitivity  <b>{sensitivity}</b></Typography>
                    <Slider
                        value={sensitivity}
                        onChange={(e, value) => setSensitivity(value)}
                        min={0}
                        marks={sensitivityMarks}
                        max={100}
                        valueLabelDisplay="on"
                    />
                </Box>

                <Button variant="contained" color="error" onClick={handleSave}>
                    Save
                </Button>
            </Box>
        </Drawer>
    );
};

export default SensitivityDrawer;
